import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import StoryCard from './StoryCard';
import { highlightDifferences } from '../utils/differenceHighlighter';

const StoryComparison = ({ factualStory, counterfactualStory, showDifferences, modelName }) => {
    const getHighlightedContent = (baseStory, compareStory) => {
        if (!baseStory || !compareStory) return null;

        return baseStory.chapters.map((chapter, index) => {
            return chapter.content.map((paragraph, pIndex) => {
                const baseText = paragraph;
                const compareText = compareStory.chapters[index]?.content[pIndex] || '';
                return highlightDifferences(baseText, compareText);
            });
        });
    };

    const factualHighlightedContent = showDifferences ? getHighlightedContent(factualStory, counterfactualStory) : null;
    const counterfactualHighlightedContent = showDifferences ? getHighlightedContent(counterfactualStory, factualStory) : null;

    

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                gap: 2,
                flexWrap: 'nowrap',
                width: '100%',
                overflowX: 'auto', 
            }}
        >
            {/* Factual Story */}
            <Paper
                sx={{
                    flex: 1,
                    margin: 1,
                    padding: 2,
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Typography variant="h5" align="center" gutterBottom>
                    Factual Version
                </Typography>
                {factualStory ? (
                    <StoryCard
                        title={factualStory.title}
                        structure={factualStory.structure}
                        chapters={factualStory.chapters}
                        analysis={factualStory.analysis}  
                        modelName={modelName} 
                        highlightedContent={factualHighlightedContent}
                    />
                ) : (
                    <Typography variant="body1" align="center">
                        No factual story selected.
                    </Typography>
                )}
            </Paper>

            {/* Counterfactual Story */}
            <Paper
                sx={{
                    flex: 1,
                    margin: 1,
                    padding: 2,
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Typography variant="h5" align="center" gutterBottom>
                    Counterfactual Version
                </Typography>
                {counterfactualStory ? (
                    <StoryCard
                        title={counterfactualStory.title}
                        structure={counterfactualStory.structure}
                        chapters={counterfactualStory.chapters}
                        analysis={counterfactualStory.analysis}  
                        modelName={modelName}
                        highlightedContent={counterfactualHighlightedContent}
                    />
                ) : (
                    <Typography variant="body1" align="center">
                        No counterfactual story selected.
                    </Typography>
                )}
            </Paper>
        </Box>
    );
};

export default StoryComparison;
